import React, { useState, useRef, useEffect } from "react";
import styled from "@emotion/styled";
import Downshift from "downshift";
import debounce from "lodash/debounce";
import { BrandListLinkTypeFilters } from "@pages/brandListComponents/BrandListLinkTypeFilters";
import { constants } from "@services";
import { Box, Text, Flex, FontAwesome, TouchableOpacity, H2 } from "@atoms";
import { SearchInput } from "@molecules";
import { SearchModalResultsQuery } from "../SearchModalResults";
// == Types ================================================================

// interface IProps {}

// == Constants ============================================================

// == Component ============================================================

const SearchModal = () => {
  const inputRef = useRef();
  const [activeLinkTypeFilter, setActiveLinkTypeFilter] = useState(null);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const onBackClick = () => {
    window.history.back();
  };

  const updateFilter = ({ linkTypeFilter }) => {
    setActiveLinkTypeFilter(linkTypeFilter);
  };

  const onStateChange = debounce(({ inputValue: newInputValue }) => {
    if (typeof newInputValue !== "undefined") {
      setInputValue(newInputValue);
    }
  }, 300);

  const stateReducer = (state, changes) => {
    switch (changes.type) {
      case Downshift.stateChangeTypes.blurInput:
      case Downshift.stateChangeTypes.mouseUp:
        return {
          ...changes,
          inputValue: state.inputValue,
        };
      default:
        return changes;
    }
  };
  return (
    <>
      <Flex alignItems="center" borderBottom="silver" p={3}>
        <TouchableOpacity onTouch={() => onBackClick()}>
          <Text color="primary">
            <FontAwesome icon="arrow-left" />
          </Text>
        </TouchableOpacity>
        <Box flex={1} ml={3} pr={2}>
          <H2>Search</H2>
        </Box>
      </Flex>
      <Downshift
        itemToString={(item) => (item ? item.value : "")}
        stateReducer={stateReducer}
        onStateChange={onStateChange}
      >
        {({
          getInputProps,
          getItemProps,
          getMenuProps,
          // isOpen,
          // inputValue,
          highlightedIndex,
          selectedItem,
        }) => (
          <div style={{ position: "relative", flex: 1 }}>
            <SearchInput
              placeholder={constants.SEARCH_PLACEHOLER}
              {...getInputProps()}
              ref={inputRef}
              containerProps={{
                m: 3,
                mb: 0,
                position: "relative",
              }}
            />
            {!!inputValue && inputValue.length > 2 && (
              <BrandListLinkTypeFilters
                borderBottom="silver"
                dispatch={updateFilter}
                linkTypeFilter={activeLinkTypeFilter}
                mb={0}
                p={3}
              />
            )}
            <EResultsContainer {...getMenuProps()}>
              <SearchModalResultsQuery
                {...{
                  inputValue,
                  getItemProps,
                  highlightedIndex,
                  selectedItem,
                  linkTypeFilter: activeLinkTypeFilter,
                }}
              />
            </EResultsContainer>
          </div>
        )}
      </Downshift>
    </>
  );
};

export default SearchModal;

// == Styles ===============================================================

// == Styles ===============================================================
const EResultsContainer = styled(Box)`
  background: white;
  overflow-y: auto;
  max-height: 80vh;
  @media only screen and (min-width: ${(props) => props.theme.breakpoints[2]}) {
    max-height: 60vh;
  }
`;
